import { render, staticRenderFns } from "./QualificationTypeDialog.vue?vue&type=template&id=a5543504"
import script from "./QualificationTypeDialog.vue?vue&type=script&lang=ts"
export * from "./QualificationTypeDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports